// EvidenceIcon.js
import React from 'react';
import { SvgIcon } from '@mui/material';

const EvidenceIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Base circle (shield) */}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        d="M12,2 C8,5 3,4 3,4 C3,4 3,9.5 3,13 C3,16.5 6.5,19.5 12,22 C17.5,19.5 21,16.5 21,13 C21,9.5 21,4 21,4 C21,4 16,5 12,2 Z"
      />

      {/* Camera lens */}
      <circle cx="12" cy="11" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.2" />

      {/* Camera body */}
      <rect x="7" y="8" width="10" height="7" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2" />

      {/* Camera flash */}
      <path fill="none" stroke="currentColor" strokeWidth="1.2" d="M16.5,6.5 L18,6.5 L18,8" />

      {/* Record dot */}
      <circle cx="16.5" cy="9.5" r="0.8" fill="currentColor" />

      {/* Surveillance lines radiating out from camera */}
      <path fill="none" stroke="currentColor" strokeWidth="0.8" strokeDasharray="0.5,0.5" d="M12,14.5 L12,17" />
      <path fill="none" stroke="currentColor" strokeWidth="0.8" strokeDasharray="0.5,0.5" d="M10,13.5 L7,16" />
      <path fill="none" stroke="currentColor" strokeWidth="0.8" strokeDasharray="0.5,0.5" d="M14,13.5 L17,16" />

      {/* Checkmark for verification/evidence */}
      <path fill="none" stroke="currentColor" strokeWidth="1.2" d="M8,18.5 L10,20.5 L16,14.5" />
    </SvgIcon>
  );
};

export default EvidenceIcon;
